module.exports = __webpack_public_path__ + "media/marketing_campaigns/recipient_list-ee07b605.svg";